<template>
  <v-sheet background-color="transparent" width="100%" height="100%">
    <v-container class="py-8 py-md-12 py-lg-16">
      <div class="d-flex flex-column justify-center">
        <TitleWidget
          v-if="title"
          class="justify-center text-center primary--text"
          :title="title"
          :subtitle="subtitle"
        />
      </div>
      <SearchProductsWidget
        :path="path"
        class="mt-4 mt-sm-6 mt-md-8 mt-lg-10"
      />

      <LoadingWidget v-if="loading" class="py-16" />

      <transition name="fade">
        <div v-if="!loading">
          <v-row v-if="items.length" class="mt-6 mt-md-8 mt-lg-10">
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              v-for="(item, key) in items"
              :key="key"
            >
              <ProductCard :item="item" />
            </v-col>

            <v-col cols="12">
              <v-pagination
                class="mt-10"
                v-model="page"
                :length="pagesLength"
                :total-visible="9"
                v-if="pagesLength > 1"
              ></v-pagination>
            </v-col>
          </v-row>

          <div v-else class="mt-10">
            <v-alert type="info" class="mt-5">
              <v-row align="center">
                <v-col class="grow">
                  Nenhum conteúdo adicionado até o momento.
                </v-col>

                <v-col class="shrink py-0">
                  <v-btn
                    color="white darken-2"
                    :to="path"
                    height="auto"
                    class="
                      d-inline-flex
                      text-body-1
                      info--text
                      font-weight-bold
                      text-none
                      py-3
                      px-5
                    "
                    depressed
                    tile
                  >
                    Todos os Produtos
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </div>
        </div>
      </transition>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import SearchProductsWidget from "../components/widgets/SearchProductsWidget.vue";
import ProductCard from "../components/cards/ProductCard.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  path: "/implementos",
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
    itemsPerPage: 24,
    totalItems: 0,
    title: "",
    subtitle: "",
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    productsCategories() {
      return this.$rest("products-categories").list.map(({ id, title }) => ({
        id,
        title: title,
        uri: formatToURL(title),
      }));
    },
    filterCategory() {
      if (!this.$route.params.category) return null;

      return this.productsCategories.filter(
        (category) => category.uri === this.$route.params.category
      )[0];
    },
  },
  beforeCreate() {
    this.$rest("articles-categories").get();
  },
  created() {
    this.get();
  },
  watch: {
    filterCategory() {
      this.get();
    },
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    get() {
      this.loading = true;
      this.items = [];

      if (this.$route.params.category && !this.filterCategory) return false;

      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.$route.query.q) params.search = this.$route.query.q;
      if (this.page) params.page = this.page;
      if (this.filterCategory) params.category = this.filterCategory.id;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { results, module_informations }) => {
            const list = results.list;
            const totalItems = results.totalItems;
            this.items = list.map(({ id, img, category, title }) => ({
              img,
              title,
              to: `${this.path}/${formatToURL(category.title)}/${formatToURL(
                title
              )}-${id}`,
            }));

            this.totalItems = totalItems;
            this.title = module_informations.title;
            this.subtitle = module_informations.subtitle;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    SearchProductsWidget,
    ProductCard,
  },
};
</script>
